import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { $t } from "../plugins/i18n";
import { verifyEmail as _verifyEmail } from "../apis/services/steemActivity";
export default {
  components: {},
  data: function data() {
    return {
      email: "",
      validationCode: "",
      isLoad: true,
      isVerifyEmail: false
    };
  },
  methods: {
    verifyEmail: function verifyEmail() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.email = _this.$route.query.email;
                _this.validationCode = _this.$route.query.verify;
                data = {
                  email: _this.email,
                  validationCode: _this.validationCode
                };
                _context.next = 5;
                return _verifyEmail(data);

              case 5:
                result = _context.sent;
                _this.isLoad = false;

                if (result.data) {
                  _this.isVerifyEmail = true;
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.verifyEmail();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};